<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
		
<!-- 第一层（替换后的“专注行业解决方案”板块） -->
<!-- 替换原“第一层（替换后的‘专注行业解决方案’板块）”为以下内容 -->
<div class="row" style="position: relative; padding: 180px 0; background: #f8faff; overflow: hidden;">
  <div style="max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between;">
    <!-- 左侧文字区域 -->
    <div style="width: 50%; padding-right: 40px;">
      <!-- 标题（带蓝色边框） -->
      <div style="font-size: 28px; font-weight: bold; color: #333; line-height: 1.4; margin-bottom: 20px; padding-left: 5px;">
        从“被动响应”到“主动预警”<br>
        筑牢城市燃气安全生命线
      </div>
      <!-- 描述文本 -->
      <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 30px;">
        我们通过物联网、大数据分析、AI算法，7×24小时实时监测管网压力、流量及设施状态，精准定位泄漏与风险，实现安全预警、应急调度的智能化，将城市燃气安全提升至全新高度。
      </div>
      <!-- 预约演示按钮 -->
      <button style="padding: 10px 20px; background: #0e0e0e; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">
        预约演示
      </button>
      <!-- 功能标签区域 -->
      <div style="display: flex; gap: 60px; margin-top: 80px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📊</span>
          综合营收
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📡</span>
          物联网采集
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">🗺️</span>
          GIS管网巡检
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">🔍</span>
          安检&工单
        </div>
        <div style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #333;">
          <span style="width: 20px; height: 20px; background: #f0f7ff; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: #409eff;">📢</span>
          监控调度
        </div>
      </div>
    </div>
    <!-- 右侧图表占位区域 -->
    <div style="width: 45%; background: #fff; border-radius: 8px; padding: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
      <!-- 这里替换为实际图表（比如ECharts），先占位 -->
      <div style="width: 100%; height: 200px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
        <img src="../../assets/img/zlindex9.png" style="width: 130%; border-radius: 8px; object-fit: cover;" />
      </div>
    </div>
  </div>
</div>


<!-- 第二层（城市燃气安全防护网板块） -->
<div style="margin: 80px auto; min-height: 300px; width: 1200px; padding: 40px; background: #f8faff; border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.05);">
  <!-- 标题区域 -->
  <div style="color: #000; font-size: 24px; font-weight: bold; text-align: center; margin-bottom: 40px;">
    构筑主动预警、快速响应的城市燃气安全防护网
  </div>

  <!-- 系统卡片区域（3列3行布局） -->
  <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; justify-items: center;">
    <!-- 第一行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5M4 19h16"/><path d="M8 17V11M12 17V7M16 17v-6"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">综合营收系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4"/><path d="M12 18v4"/><path d="m4.93 4.93 2.83 2.83"/><path d="m16.24 16.24 2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="m4.93 19.07 2.83-2.83"/><path d="m16.24 7.76 2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">物联网采集系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/><path d="M9 17h6"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">GIS管网监控系统</div>
    </div>

    <!-- 第二行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M3 12h10l4-6 4 6h4"/><circle cx="7" cy="6" r="1.5" fill="currentColor" stroke="none"/><circle cx="17" cy="12" r="1.5" fill="currentColor" stroke="none"/><path d="M3 18h18"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">GIS管网巡检系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="m9 12 2 2 4-4"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">安检/工单系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 13V9M12 13V7M17 13v-2"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">SCADA监控系统</div>
    </div>

    <!-- 第三行 -->
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="11" width="7" height="10" rx="1"/><rect x="3" y="15" width="7" height="6" rx="1"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">智慧燃气驾驶舱</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-3"/><path d="M9 9v1"/><path d="M9 13v1"/><path d="M9 17v1"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">工商户监控系统</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 20px; text-align: center;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></svg>
      </div>
      <div style="font-size: 16px; color: #333; font-weight: 500;">移动端(掌上营业厅)</div>
    </div>
  </div>
</div>

<div style="background: linear-gradient(338deg, rgb(238, 238, 255), transparent);padding-top: 20px;padding-bottom: 20px;">
  <!-- 第三层（市场洞察：综合营收+物联网采集系统板块） -->
<div style="margin: 80px auto; min-height: 400px; width: 1200px; padding: 40px; ">
  <!-- 顶部标题 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">市场洞察</div>

  <!-- 内容分栏（上下两部分） -->
  <div style="display: flex; flex-direction: column; gap: 60px;">
    <!-- 第一部分：综合营收系统 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 左侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">综合营收系统</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
        <p style="margin-top: 10px;">手抄表、IC卡、物联网表三表合一缴费；</p>
          <p style="margin-top: 10px;">跟随录入口径随时统计、抄表价格统计、评价管理；</p>
          <p style="margin-top: 10px;">全方位在户资料信息查询，可根据资料信息变更；</p>
           <p style="margin-top: 10px;">发票、收据样式自定义且可管理，实现电子发票开具；</p>
           <p style="margin-top: 10px;">支持多种促销信息、自定义文本；</p>
           <p style="margin-top: 10px;">灵活的的管理及批量处理用户；</p>
          <p style="margin-top: 10px;">多方位数据报表呈现及导出；</p>
           <p style="margin-top: 10px;">银行代扣、支付宝、微信等相关数据统计功能；</p>
        </div>
      </div>
      <!-- 右侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
        <div style="width: 100%; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
           <img src="../../assets/img/zlindex10.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        </div>
        <!-- <div style="width: 80%; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
         <img src="../../assets/img/gywmBanner.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        </div> -->
        <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
      </div>
    </div>

    <!-- 第二部分：物联网采集系统 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 左侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
        <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px;"></div> -->
        <div style="width: 100%; height: 120px;  border-radius: 4px; display: flex; justify-content: center; align-items: center;">
           <!-- <img src="../../assets/img/EAMimg.png" style="width: 100%; border-radius: 8px; object-fit: cover;" /> -->
			     <img src="../../assets/img/zlindex11.png" style="width: 70%; border-radius: 8px; object-fit: cover;" />
        </div>
        <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; align-self: flex-end;"></div> -->
      </div>
      <!-- 右侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">时间追踪器</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">物联网采集系统</div>
        <div style="font-size: 14px; color: #666; line-height: 28px!important;">
           <p style="margin-top: 10px;line-height: 18px;">实时监控与预警——即时发现并规避安全问题，提升安全响应效率，减少人工巡检成本；</p>
           <p style="margin-top: 10px;line-height: 18px;">多中心数据采集与备——大数据接入组态系统，保障数据有效共享，快速定位事故位置；</p>
          <p style="margin-top: 10px;line-height: 18px;">智能预警与趋势分析——提供异常天气预警条件，为分析决策提供相应数据基础；</p>
          <p style="margin-top: 10px;line-height: 18px;">并记录所有运行日志——实现数据可视化，优化运营策略，全方位提供数据基础数据支持；</p>
          <p style="margin-top: 10px;line-height: 18px;">远程控制指令下发——远程隔离事故，提升应急效率，保障用户用气安全；</p>
        </div>
      </div>
    </div>
  </div>


</div>

</div>

<!-- 第四层（GIS管网监控+巡检系统板块） -->
<div style="margin: 80px auto; min-height: 500px; width: 1200px; padding: 40px;">
  <!-- 顶部标题 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">市场洞察</div>

  <!-- 内容分栏（上下两部分） -->
  <div style="display: flex; flex-direction: column; gap: 60px;">
    <!-- 第一部分：GIS管网监控系统 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 左侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">GIS管网监控系统</div>
        <div style="font-size: 14px; color: #666; line-height: 18px;">
           <p style="margin-top: 10px;"><b>管网数据可视化：</b></p>
           <p style="margin-top: 10px;line-height: 18px;">整合各管网相关专业数据和地理信息，包括管网位置、管网材质、在地图上直观展示，方便管理人员清晰掌握管网信息。</p>
           <p style="margin-top: 10px;"><b>实时监测预警：</b></p>
           <p style="margin-top: 10px;line-height: 18px;">与传感器对接，实时获取管网压力、流量、温度等数据，及时发现异常变化。</p>
           <p style="margin-top: 10px;"><b>故障分析与应急管理：</b></p>
           <p style="margin-top: 10px;line-height: 18px;">故障发生时精准定位，分析可能造成的影响范围，辅助快速出警、维修制定应急计划，减少损失。</p>
           <p style="margin-top: 10px;"><b>应急处置：</b></p>
           <p style="margin-top: 10px;line-height: 18px;">在突发事件（如爆管）时，快速定位位置，提供周边环境信息及救援信息，辅助应急抢险人员快速有效处置，提高应急处理效率。</p>
        </div>
      </div>
      <!-- 右侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
	   <img src="../../assets/img/zlindex12.png" style="width: 80%; border-radius: 8px; object-fit: cover;" />
        <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
          <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
        </div> -->
        <!-- <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
          <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">饼图</div>
          <div style="width: 120px; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">环形图</div>
        </div> -->
        <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
      </div>
    </div>

    <!-- 第二部分：GIS管网巡检系统 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 左侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
		  <img src="../../assets/img/zlindex13.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
        <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <div style="height: 60%; background: #fff; flex: 1; border-radius: 2px;"></div>
        </div>
        <div style="width: 100%; height: 180px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
          <div style="text-align: center;">
            <div style="width: 80px; height: 80px; background: #f0f7ff; border-radius: 4px; margin: 0 auto 10px; display: flex; justify-content: center; align-items: center; color: #409eff;">饼图</div>
            <div style="height: 40px; background: #e1f5ff; border-radius: 4px;"></div>
          </div>
        </div> -->
      </div>
      <!-- 右侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">时间追踪器</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">GIS管网巡检系统</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
          <p style="margin-top: 10px;"><b>计划制定：</b></p>
          <p style="margin-top: 10px;">管理者可根据巡检要求及每个片区日常巡检的计划，自动生成派发。</p>
          <p style="margin-top: 10px;"><b>任务执行：</b></p>
          <p style="margin-top: 10px;">巡检人员通过设备接收任务并按照巡检计划，到岗签到。</p>
          <p style="margin-top: 10px;"><b>问题处理：</b></p>
          <p style="margin-top: 10px;">管理人员快速生成整改工单，指派处理人员，跟踪处理要求，完成时效等。</p>
          <p style="margin-top: 10px;"><b>轨迹查看：</b></p>
          <p style="margin-top: 10px;">查看巡检当天的轨迹，支持轨迹回放。</p>
        </div>
      </div>
    </div>
  </div>
</div>


<div style="background: linear-gradient(338deg, rgb(238, 238, 255), transparent);padding-top: 20px;padding-bottom: 20px;">
  <!-- 第五层（安检&工单系统+SCADA监控系统板块） -->
<div style="margin: 80px auto; min-height: 500px; width: 1200px; padding: 40px; ">
  <!-- 顶部标题 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">市场洞察</div>

  <!-- 内容分栏（上下两部分） -->
  <div style="display: flex; flex-direction: column; gap: 60px;">
    <!-- 第一部分：安检&工单系统 -->
    <div style="display: flex; justify-content: space-between; align-items: flex-start;">
      <!-- 左侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">安检&工单系统</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
          <p style="margin-top: 10px;line-height: 18px;">安检系统面向工商户、居民户，户内安全管理的统一平台，从安检计划、安检执行、隐患闭环管理、通过现场拍照、定位等多方面全方位实现安检业务线上化管理平台。工单系统解决燃气企业移动端工单管理，这样可实时记录现场情况，支持拍照、收费、现场签名等。</p>
          <p style="margin-top: 10px;line-height: 18px;"><b>工单发起：</b>无纸化作业，用户线上发起报装、维修、点火、改建、投诉等业务。</p>
          <p style="margin-top: 10px;line-height: 18px;"><b>工单处理：</b>后台根据公司处理工单，支持指派、自动派单。</p>
          <p style="margin-top: 10px;line-height: 18px;"><b>安检计划：</b>管理人员制定安检计划制定安检人员上门安检。</p>
          <p style="margin-top: 10px;line-height: 18px;"><b>安检上门：</b>安检员根据计划上门安检，记录安检情况（如：正常入户、到访不遇、空房等）。</p>
         <p style="margin-top: 10px;line-height: 18px;"><b>表单配置：</b>灵活的表单配置功能，根据燃气公司实际情况要求安检人员填写表单。</p>
        </div>
      </div>
      <!-- 右侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
		  <img src="../../assets/img/zlindex14.png" style="width: 80%; border-radius: 8px; object-fit: cover;" />
        <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
          <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
        </div>
        <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
          <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">饼图</div>
          <div style="width: 120px; height: 120px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">环形图</div>
        </div> -->
      </div>
    </div>

    <!-- 第二部分：SCADA监控系统 -->
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <!-- 左侧图表占位 -->
      <div style="width: 45%; display: flex; flex-direction: column; gap: 20px;">
			  <img src="../../assets/img/zlindex15.png" style="width: 80%; border-radius: 8px; object-fit: cover;" />
        <!-- <div style="width: 60%; height: 40px; background: #409eff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
          <div style="height: 60%; background: #fff; flex: 1; border-radius: 2px;"></div>
        </div> -->
        <!-- <div style="width: 100%; height: 180px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">
          <div style="text-align: center; width: 100%;">
            <div style="width: 80px; height: 80px; background: #f0f7ff; border-radius: 4px; margin: 0 auto 10px; display: flex; justify-content: center; align-items: center; color: #409eff;">饼图</div>
            <div style="height: 40px; background: #e1f5ff; border-radius: 4px; width: 80%; margin: 0 auto;"></div>
            <div style="height: 20px; background: #f0f7ff; border-radius: 2px; width: 60%; margin: 10px auto 0;"></div>
          </div>
        
		</div> -->
      </div>
      <!-- 右侧文字区域 -->
      <div style="width: 45%;">
        <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 30px;">时间追踪器</div>
        <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">SCADA监控系统</div>
        <div style="font-size: 14px; color: #666; line-height: 22px;">
          <p style="margin-top: 10px;line-height: 18px;">系统动态可视化展示压力、流量、温度等关键参数，自动定位异常预警（如压力骤降、流量突变），支持快速应急关断。</p>
          <p style="margin-top: 10px;line-height: 18px;">基于用气历史数据与气象因素，智能预测区域用气高峰，自动生成调峰方案（如LNG补气、管网压力调节）。</p>
          <p style="margin-top: 10px;line-height: 18px;">远程控制站场调峰、调压器、压缩机等设备参数，实现无人化运维（如调压器压力调节、冬季保供）。</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 第六层（工商户在线监控板块） -->
<div style="margin: 80px auto; min-height: 300px; width: 1200px; padding: 40px; ">
  <!-- 顶部标题 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 10px;">市场洞察</div>

  <!-- 内容区域（左文右图） -->
  <div style="display: flex; justify-content: space-between; align-items: center; gap: 40px;">
    <!-- 左侧文字区域 -->
    <div style="width: 45%;">
      <div style="font-size: 22px; font-weight: bold; color: #333; margin-bottom: 20px;">工商户在线监控</div>
      <div style="font-size: 14px; color: #666; line-height: 24px;">
        <p style="margin-top: 10px;line-height: 18px;">实时高精度采集工商业用户用气数据（如温度、压力、瞬时流量），超阈值自动告警（短信/平台），防止偷气或管道泄漏。</p>
        <p style="margin-top: 10px;line-height: 18px;">支持远程紧急关阀（如泄漏预警）或计划性关阀（如欠费停气），减少人工干预，提升安全管理效率。</p>
        <p style="margin-top: 10px;line-height: 18px;">智能诊断计量计电池、通讯、传感状态，预测性维护提醒，降低设备故障率。</p>
      </div>
    </div>

    <!-- 右侧图表占位 -->
    <div style="width: 45%; display: flex; flex-direction: column; gap: 20px; align-items: flex-end;">
		  <img src="../../assets/img/zlindex16.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />
      <!-- 顶部小卡片 -->
      <!-- <div style="width: 80%; height: 40px; background: #e1f5ff; border-radius: 4px; display: flex; align-items: center; padding: 0 10px;">
        <span style="width: 16px; height: 16px; background: #409eff; border-radius: 50%; margin-right: 8px;"></span>
        <div style="height: 60%; background: #ddd; flex: 1; border-radius: 2px;"></div>
      </div> -->
      <!-- 图表组合 -->
      <!-- <div style="width: 100%; display: flex; gap: 20px; align-items: center;">
        <div style="width: 80px; height: 80px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">饼图</div>
        <div style="width: 140px; height: 140px; background: #f9f9f9; border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #ccc;">环形图</div>
      </div> -->
      <!-- 底部小卡片 -->
      <!-- <div style="width: 60%; height: 40px; background: #e1f5ff; border-radius: 4px;"></div> -->
    </div>
  </div>
</div>

</div>





<!-- 第七层（核心优势-产品特点板块） -->
<div style="margin: 80px auto; min-height: 250px; width: 1200px; padding: 40px;  text-align: center;">
  <!-- 顶部标题 -->
  <div style="font-size: 18px; color: #409eff; font-weight: 500; margin-bottom: 5px;">核心优势</div>
  <div style="font-size: 28px; font-weight: bold; color: #333; margin-bottom: 40px;">产品特点</div>

  <!-- 三栏卡片区域 -->
  <div style="display: flex; justify-content: space-between; gap: 20px;">
    <!-- 卡片1：运营管理一体化 -->
    <div style="flex: 1; padding: 30px 20px; background: #f9f5ff; border-radius: 8px;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff; margin: 0 auto 15px;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.59 13.51 6.83 3.98"/><path d="m15.41 6.51-6.82 3.98"/></svg>
      </div>
      <div style="font-size: 18px; font-weight: 600; color: #333; margin-bottom: 10px;">运营管理一体化</div>
      <div style="font-size: 14px; color: #666; line-height: 22px;">
        打通客服、收费、账务等核心业务流程，通过统一的综合营收平台进行高效管理。
      </div>
    </div>

    <!-- 卡片2：管网监控主动化 -->
    <div style="flex: 1; padding: 30px 20px; background: #f9f5ff; border-radius: 8px;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff; margin: 0 auto 15px;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="M20 12h2"/><path d="m19.07 4.93-1.41 1.41"/><path d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z"/><path d="M12 8v4l3 2"/></svg>
      </div>
      <div style="font-size: 18px; font-weight: 600; color: #333; margin-bottom: 10px;">管网监控主动化</div>
      <div style="font-size: 14px; color: #666; line-height: 22px;">
        通过集成SCADA、GIS以及各类监控系统，构建了从主干网到工商业用户的全方位立体监控网络。
      </div>
    </div>

    <!-- 卡片3：现场作业闭环化 -->
    <div style="flex: 1; padding: 30px 20px; background: #f9f5ff; border-radius: 8px;">
      <div class="whzl-sys-icon" style="width: 48px; height: 48px; background: #e1f5ff; border-radius: 8px; display: flex; justify-content: center; align-items: center; color: #409eff; margin: 0 auto 15px;" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>
      </div>
      <div style="font-size: 18px; font-weight: 600; color: #333; margin-bottom: 10px;">现场作业闭环化</div>
      <div style="font-size: 14px; color: #666; line-height: 22px;">
        基于GIS地图，为巡检、安检、维修等外勤任务提供智能派单与标准化作业流程。
      </div>
    </div>
  </div>
</div>
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				index:0
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			enter(e){
				this.index=e
			},
			leave(){
				this.index=0
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		min-width: 1400px;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		/* background: #f7f7f7; */
	}

	.prduct-box {
		width: 1200px;
		/* padding-top: 60px; */
		padding-bottom: 100px;
		margin: 0 auto;
	}

	.center-body {
		margin: 0 auto;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
	.hxyx-box{
		height: 793px;
		background-image: url(../../assets/img/gywmbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	.active{
		color: #fff !important;
		background-color: #0070FD !important;
	}

	.whzl-sys-icon svg {
		display: block;
		flex-shrink: 0;
	}
</style>
